/* Shared doc access for the internal blog-design lab.
   Every variant renders the same real post so the owner compares layout only. */
import { computed } from 'vue';
import { tocLinksFrom } from './blog-design-utils';

export const BLOG_DESIGN_CONTENT_PATH = '/blog/best-crm-for-agencies';

export async function useBlogDesignDoc() {
  const { data: doc } = await useAsyncData('internal-blog-design-doc', () =>
    queryContent(BLOG_DESIGN_CONTENT_PATH).findOne(),
  );

  const tocLinks = computed(() => tocLinksFrom(doc.value));

  return { doc, tocLinks, contentPath: BLOG_DESIGN_CONTENT_PATH };
}
